import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  q: '¿Qué tipo de contenido incluye esta guía?',
  a: 'Esta guía incluye información clara y práctica sobre alimentación natural para perros: qué alimentos son beneficiosos, cuáles evitar, cómo hacer la transición de forma segura, y recetas fáciles para el día a día. Todo explicado de forma simple, sin tecnicismos.'
}, {
  q: '¿Este material es solo para personas con experiencia?',
  a: 'Para nada. Esta guía fue creada pensando en cualquier dueño de perro, sin importar si nunca preparaste comida natural. Todo está explicado paso a paso, de forma clara y fácil de seguir.'
}, {
  q: '¿Voy a aprender cómo alimentar correctamente a mi perro?',
  a: 'Sí. Vas a entender qué necesita tu perro para estar bien nutrido, qué alimentos le hacen bien, cuáles le hacen mal, y cómo armar comidas equilibradas sin complicarte.'
}, {
  q: '¿Incluye ejemplos prácticos o recetas reales?',
  a: 'Sí, incluye recetas reales con ingredientes que podés conseguir en cualquier supermercado. Son recetas simples, rápidas y pensadas para el día a día.'
}, {
  q: '¿En qué formato recibo el material?',
  a: 'Recibís todo en formato digital (PDF), listo para leer desde tu celular, tablet o computadora. Podés acceder en cualquier momento, desde cualquier lugar.'
}, {
  q: '¿Puedo imprimir el contenido?',
  a: '¡Por supuesto! El material es tuyo y podés imprimirlo todas las veces que quieras para tenerlo siempre a mano en tu cocina.'
}, {
  q: '¿Cuánto tarda en llegar el material después de la compra?',
  a: 'El acceso es inmediato. Apenas completás tu compra, recibís el material en tu correo electrónico para que puedas empezar a leerlo de inmediato.'
}, {
  q: '¿Necesito conocimientos previos sobre nutrición canina?',
  a: 'No necesitás saber nada previo. La guía está diseñada para que cualquier persona pueda entenderla y aplicarla, incluso si nunca escuchaste hablar de alimentación natural para perros.'
}, {
  q: '¿Este contenido realmente mejora la salud de mi perro?',
  a: 'Miles de dueños alrededor del mundo han visto mejoras reales en la salud de sus perros al cambiar a una alimentación natural: mejor digestión, más energía, pelo más brillante y mayor bienestar general. Esta guía te da las herramientas para lograrlo.'
}, {
  q: '¿Tengo acceso para siempre al material?',
  a: 'Sí, el acceso es de por vida. Una vez que lo comprás, es tuyo para siempre. Podés volver a consultarlo cuando quieras, sin límites.'
}, {
  q: '¿Es un pago único?',
  a: 'Sí, es un pago único. No hay suscripciones, cargos ocultos ni pagos recurrentes. Pagás una sola vez y tenés acceso completo a todo el contenido y los bonos.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-stone-50" data-id="element-65">
      <div className="max-w-3xl mx-auto px-4" data-id="element-66">
        <div className="text-center mb-12" data-id="element-67">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-68">
            Resolvé acá tus dudas
          </h2>
          <p className="text-lg text-stone-600 font-medium" data-id="element-69">
            Hacé clic para ver la respuesta que necesitás
          </p>
        </div>

        <div className="space-y-4" data-id="element-70">
          {FAQS.map((faq, index) => <div key={index} className="bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden transition-all duration-300 hover:shadow-md" data-id="element-71">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index} data-id="element-72">
                <span className="font-bold text-stone-800 text-lg pr-8" data-id="element-73">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-emerald-600 flex-shrink-0 transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-74" />
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-75">
                <p className="text-stone-600 leading-relaxed" data-id="element-76">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}